import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { FormGroup, FormControl } from '@angular/forms'
import { Observable, Subject } from 'rxjs'
import { takeUntil, debounceTime, map } from 'rxjs/operators'
import Swal from 'sweetalert2'
import { IOrderFilter, SortType } from '../interface'
import { ServiceOrderService } from '../service-order.service'

@Component({
  selector: 'app-order-filter',
  templateUrl: './order-filter.component.html',
  styleUrls: ['./order-filter.component.scss'],
})
export class OrderFilterComponent implements OnInit, OnDestroy {
  dateRange: Date[]
  isLoading: boolean = false
  @Input()
  set filter(filter: IOrderFilter) {
    this.filterFormGroup.setValue(filter, { emitEvent: false })
  }

  @Output()
  onDownload: EventEmitter<Partial<IOrderFilter>> = new EventEmitter()

  @Output()
  filterUpdate: EventEmitter<Partial<IOrderFilter>> = new EventEmitter()

  sortType$: Observable<SortType> = this.serviceOrderState.sortType$
  private unsubscribe$ = new Subject()

  filterFormGroup: FormGroup = new FormGroup({
    farmer_name: new FormControl(),
    service_name: new FormControl(),
    status: new FormControl(),
    dateRange: new FormControl(),
  })

  services$ = this.serviceOrderState.serviceList$
  totalOrders$ = this.serviceOrderState.currentServiceOrders$.pipe(
    map((orders) => orders.total)
  )
  statuses = ['new', 'completed', 'failed']
  constructor(private serviceOrderState: ServiceOrderService) { }

  ngOnInit() {
    this.filterFormGroup
      .get('service_name')
      .valueChanges.pipe(takeUntil(this.unsubscribe$), debounceTime(350))
      .subscribe((value: IOrderFilter['service_name']) => {
        this.filterUpdate.emit({
          service_name: value,
        })
      })

    this.filterFormGroup
      .get('status')
      .valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe((value) => {
        this.filterUpdate.emit({
          status: value,
        })
      })
    this.filterFormGroup
      .get('farmer_name')
      .valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe((value) => {
        this.filterUpdate.emit({
          farmer_name: value,
        })
      })
  }

  public get sortOptions() {
    return this.serviceOrderState.sortOptions
  }

  onRangeChange() {
    this.filterUpdate.emit({
      dateRange: this.dateRange,
    })
  }

  changeSort(value: SortType) {
    this.serviceOrderState.changeServiceOrderSort(value)
  }

  download() {
    this.isLoading = true
    // this.onDownload.emit()
    this.serviceOrderState.downloadServices().subscribe(
      (res: any) => {
        this.isLoading = false
        Swal.fire({
          title: `Services download will be sent to your email: ${res.email}`,
          type: 'success',
          timer: 2000,
        })
      },
      (err) => {
        this.isLoading = false
        Swal.fire({
          title: 'Download failed',
          type: 'error',
          text: 'Please try again',
          timer: 2000,
        })
      }
    )
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }
}
